/**
 * @module lib/commercial/keytar/flash-sale-paywall-hard
 */
import template from "./template";
import tgamConfig from "config/tgam";
import Wall from "lib/commercial/keytar/Wall";
import { WALL_TYPES } from "lib/commercial/keytar/WallAnalyticsSchema";
import { isFreeToViewReferrer } from "lib/commercial/keytar/helpers";
import isNil from "lodash/isNil";
import { getProp } from "utils/utils";
import logger from "utils/logger";
import { processObjectMethods } from "../helpers";
import { isTimedEnabledFeature } from "utils/time-restricted";
import { isYellowCoronaArticle } from "utils/story";

const name = "flashSalePaywallHard";
const debugTag = `[KEYTAR] ${name}`;

const epochNow = Math.floor(new Date().getTime() / 1000); // mockable global var
const wallStart = parseInt(getProp(tgamConfig, "keytar.flashSaleWallsStart", 0), 10);
const wallEnd = parseInt(getProp(tgamConfig, "keytar.flashSaleWallsEnd", 0), 10);

const rules = [{
  /** @returns {Boolean} true when access is allowed for user */
  accessAllowed({ customer, gam }) {
    if (isNil(customer)) {
      return false;
    }
    const allowed = {
      isFreeToView: () => isFreeToViewReferrer(),
      isSub: () => customer.canAccessSubscriberContent,
      isSpecialAccess: () => {
        return customer.canAccessRegisteredContent && isYellowCoronaArticle(gam);
      }
    };
    const access = processObjectMethods(allowed);
    logger.info(`${debugTag} access:`, access, allowed);
    return access;
  },
  /** @returns {Boolean} true when wall should be used for article page */
  matcher({ paywallStatus }) {
    return ["red"].includes(paywallStatus);
  },
  /** @type {String} */
  name: name
}];

const props = {
  rules,
  suppressed: params => { // optional override params for automated testing
    return !isTimedEnabledFeature({
      start: getProp(params, "start") || wallStart,
      now: getProp(params, "now") || epochNow,
      end: getProp(params, "end") || wallEnd
    });
  },
  featureFlagName: "flashSaleWallsEnabled", // defined in environment-variables.jsp, shared with other walls
  template
};

export default new Wall("redwall", WALL_TYPES.PAYWALL_HARD, props);
